import React from "react";

import MainButton from "../main-button";
import Loader from "../loader";
import ModalWithChildren from "../modal-with-children";
import LeftInfoModal from "../left-info-modal";
import Portal from "../portal/portal";
import { Button } from "../buttons";
import { images } from "../../assets";
import { ModalContent } from "./export-button-style";

import { useExportInsureds } from "../../hooks/export-insureds-hook/useExportInsureds";
import { FLOW_AREA } from "../../constants/flow";
import { ExportInsuredsButtonProps } from "./export-button-types";

const ExportInsuredsButton = ({ getCsvData, flow }: ExportInsuredsButtonProps) => {
  const {
    loading,
    optionsModalActive,
    errorModal,
    openOptionsModal,
    closeOptionsModal,
    exportTemplate,
    exportData,
    resetErrorModal,
  } = useExportInsureds({ getCsvData, flow, fileName: "asegurados.csv" });

  if (loading) {
    return (
      <Portal>
        <Loader isLoadingMsg="Descargando archivo..." />
      </Portal>
    );
  }

  return (
    <>
      <div className="upload-button">
        <MainButton
          onClick={openOptionsModal}
          text="Exportar asegurados"
          type={flow === FLOW_AREA.CONTRATACION ? "full-light" : ""}
        />
      </div>

      <Portal>
        <ModalWithChildren
          active={optionsModalActive}
          close={closeOptionsModal}
          mainTitle="¿Qué acción desea realizar"
          img={images.IconInfoBlue}
        >
          <ModalContent>
            <Button onClick={exportTemplate} text="Exportar plantilla" />
            <Button onClick={exportData} text="Exportar asegurados" />
          </ModalContent>
        </ModalWithChildren>
      </Portal>

      <Portal>
        <LeftInfoModal
          img={images.IconWarningYellow}
          className="error"
          mainTitle={errorModal.mainTitle}
          mainText={errorModal.mainText}
          buttonText="Aceptar"
          onClickAccept={resetErrorModal}
          close={resetErrorModal}
          active={errorModal.active}
          noSecondaryButton
          centerPrimaryButton
        />
      </Portal>
    </>
  );
};

export default ExportInsuredsButton;
